module.exports = __webpack_public_path__ + "static/media/eye.8dc36d5d.png";